// extracted by mini-css-extract-plugin
export default {"table":"ModalDenominationStatusInfoVersion2_table__HqLEu"};